import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useIntl } from "react-intl";
import _ from "lodash";
import { Box } from "@mui/material";
import { useFetchTicketList } from "features/metadesk/redux/hooks";
import TicketTable from "features/metadesk/components/TicketTable";
import { StyledTitle } from "./UserInfo.style";
import WhiteCard from "../WhiteCard";

import useNavigateEntity from "hooks/useNavigateEntity";

const UserTicketHistory = ({ selectedUserIdsOrUid, isTicketUserInfo }) => {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();

  const rowsPerPage = 10;

  const {
    fetchUserTicketList,
    userTicketList,
    ticketListFilter,
    updateTicketListFilter,
    fetchUserTicketListPending,
    userTicketCounts,
    userTicketAvgScoring,
  } = useFetchTicketList();

  const page = _.get(ticketListFilter, `page`, 1);
  const orderData = _.get(ticketListFilter, `orderData`);
  const searchText = _.get(ticketListFilter, "searchText", "");

  useEffect(() => {
    fetchUserTicketList({
      entityName,
      ...(isTicketUserInfo
        ? { userIds: selectedUserIdsOrUid }
        : { uid: [selectedUserIdsOrUid[0]] }),
      filter: ticketListFilter,
      limit: rowsPerPage,
    });
  }, []);

  const { navigateEntity } = useNavigateEntity();
  return (
    <Box
      sx={
        isTicketUserInfo
          ? { padding: "16px", backgroundColor: "#FAFAFD" }
          : { marginTop: "16px" }
      }
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
          marginBottom: "16px",
        }}
      >
        <WhiteCard
          label={
            <Box>
              {formatMessage({ id: "ticketHistory.ticketCount.title" })}{" "}
              {/* <IconTooltip
                content={formatMessage({
                  id: "customerAnalysis.matrix.tooltip.userCount",
                })}
              /> */}
            </Box>
          }
          isLoading={fetchUserTicketListPending}
          value={userTicketCounts}
          width="100%"
          className="general-shadow"
        />
        <WhiteCard
          label={
            <Box>
              {formatMessage({ id: "ticketHistory.avgScoring.title" })}{" "}
              {/* <IconTooltip
                content={formatMessage({
                  id: "customerAnalysis.matrix.tooltip.totalWalletCount",
                })}
              /> */}
            </Box>
          }
          value={userTicketAvgScoring === null ? "-" : userTicketAvgScoring}
          isLoading={fetchUserTicketListPending}
          width="100%"
          className="general-shadow"
        />
      </Box>

      {/* Tickets */}
      <Box>
        <StyledTitle>
          {formatMessage({ id: "ticketHistory.uesrTickets.title" })}
        </StyledTitle>
        <div style={{ marginTop: 8, position: "relative" }}>
          {userTicketList && (
            <TicketTable
              setOpenTicketDetail={(ticketId) => {
                navigateEntity(`/service/ticket/all?ticketId=${ticketId}`);
              }}
              loading={fetchUserTicketListPending}
              orderData={orderData}
              noDataTitle={formatMessage({
                id: "ticketHistory.noData.userTicket.title",
              })}
              setOrderData={(v) => updateTicketListFilter({ orderData: v })}
              ticketList={userTicketList}
              entityName={entityName}
              dataCounts={userTicketCounts}
              page={page}
              setPage={(v) => updateTicketListFilter({ page: v })}
              loadingIndicatorAmount={rowsPerPage}
              rowsPerPage={rowsPerPage}
              isUserInfoPage
            />
          )}
        </div>
      </Box>
    </Box>
  );
};

export default UserTicketHistory;
